import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Consultation from './pages/Consultation';
import StudentVisa from './pages/services/StudentVisa';
import WorkVisa from './pages/services/WorkVisa';
import FamilyVisa from './pages/services/FamilyVisa';
import VisitorVisa from './pages/services/VisitorVisa';
import BusinessVisa from './pages/services/BusinessVisa';
import Appeals from './pages/services/Appeals';
import UKImmigrationChanges2024 from './pages/news/UKImmigrationChanges2024';
import StudentVisaGuidelines from './pages/news/StudentVisaGuidelines';
import SkilledWorkerUpdates from './pages/news/SkilledWorkerUpdates';
import ArticleList from './pages/admin/ArticleList';
import CreateArticle from './pages/admin/CreateArticle';
import Blog from './pages/Blog';
import ArticleView from './pages/ArticleView';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/student-visa" element={<StudentVisa />} />
      <Route path="/services/work-visa" element={<WorkVisa />} />
      <Route path="/services/family-visa" element={<FamilyVisa />} />
      <Route path="/services/visitor-visa" element={<VisitorVisa />} />
      <Route path="/services/business-visa" element={<BusinessVisa />} />
      <Route path="/services/appeals" element={<Appeals />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/consultation" element={<Consultation />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<ArticleView />} />
      <Route path="/news/uk-immigration-changes-2024" element={<UKImmigrationChanges2024 />} />
      <Route path="/news/student-visa-guidelines" element={<StudentVisaGuidelines />} />
      <Route path="/news/skilled-worker-updates" element={<SkilledWorkerUpdates />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      
      {/* Admin Routes */}
      <Route path="/admin/articles" element={<ArticleList />} />
      <Route path="/admin/create-article" element={<CreateArticle />} />
      <Route path="/admin/edit-article/:id" element={<CreateArticle />} />
    </RouterRoutes>
  );
};

export default Routes; 